const API_URL = process.env.API_URL

export const apiFetch = async ({ path, method = 'GET', payload }) => {
  const options = {
    method,
    body: payload ? JSON.stringify(payload) : null,
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include'
  }
  const res = await fetch(`${API_URL}${path}`, options)
  if (res.status === 204 || res.headers.get('content-length') === '0') return null
  const data = await res.json()
  if (!res.ok) throw Object.assign(new Error(data?.error || data?.message || `HTTP ${res.status}`), { status: res.status, data })
  return data
}
